// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Component, Input } from '@angular/core';
import { UserState } from '../../../state/user-details/user-details.interfaces';

@Component({
  selector: 'app-user-details-card',
  templateUrl: './user-details-card.component.html',
  styleUrls: ['./user-details-card.component.scss']
})
export class UserDetailsCardComponent {
  @Input() user: UserState | undefined;
}



// WEBPACK FOOTER //
// ./src/app/access-management/users/user-details/user-details-card/user-details-card.component.ts